import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ClothHangerIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.5 3.625C6.5 3.00368 7.00368 2.5 7.625 2.5H8.10389C8.61826 2.5 9.03524 2.91698 9.03524 3.43135V3.5C9.03524 3.91421 9.37103 4.25 9.78524 4.25C10.1995 4.25 10.5352 3.91421 10.5352 3.5V3.43135C10.5352 2.08855 9.44669 1 8.10389 1H7.625C6.17525 1 5 2.17525 5 3.625V3.74979C5 5.04626 5.98679 6.11226 7.25027 6.23766V7.19881C7.12985 7.25594 7.0145 7.32758 6.90678 7.41375L1.72506 11.5591C1.26678 11.9258 1 12.4808 1 13.0677C1 14.1347 1.86496 14.9996 2.93193 14.9996H13.0681C14.135 14.9996 15 14.1347 15 13.0677C15 12.4808 14.7332 11.9258 14.2749 11.5591L9.09322 7.41375C8.98566 7.32771 8.87049 7.25615 8.75027 7.19906V6.00006C8.75027 5.30967 8.1906 4.75 7.50021 4.75C6.94781 4.75 6.5 4.30219 6.5 3.74979V3.625ZM7.84383 8.58506C7.93513 8.51201 8.06487 8.51201 8.15617 8.58506L13.3379 12.7304C13.4404 12.8124 13.5 12.9365 13.5 13.0677C13.5 13.3063 13.3066 13.4996 13.0681 13.4996H2.93193C2.69338 13.4996 2.5 13.3063 2.5 13.0677C2.5 12.9365 2.55965 12.8124 2.66211 12.7304L7.84383 8.58506Z"
			></path>
		</svg>
	),
)
